if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();
        // Per the Web Components contract, the constructor must not query
        // DOM children. The parent DetailsDisclosure resolves
        // `mainDetailsToggle` in connectedCallback (not in its
        // constructor), so accessing `this.mainDetailsToggle.setAttribute`
        // here threw "Cannot read properties of undefined (reading
        // 'setAttribute')". All children-dependent wiring is deferred to
        // connectedCallback below, after super.connectedCallback() has
        // had a chance to resolve mainDetailsToggle. (Noibu issue 884.)
      }

      connectedCallback() {
        super.connectedCallback();

        if (this._shareButtonInitialized) return;
        this._shareButtonInitialized = true;

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

        if (navigator.share) {
          // mainDetailsToggle is set by DetailsDisclosure when the markup
          // includes a <details> wrapper. PDP variants that prefer the
          // native share UX render <share-button> without that wrapper,
          // so the toggle is genuinely optional here. The native share
          // button is the path that actually runs in those cases.
          this.mainDetailsToggle?.setAttribute('hidden', '');
          if (this.elements.shareButton) {
            this.elements.shareButton.classList.remove('hidden');
            this.elements.shareButton.addEventListener('click', () => {
              navigator.share({ url: this.urlToShare, title: document.title });
            });
          }
        } else if (this.mainDetailsToggle) {
          this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
          this.mainDetailsToggle
            .querySelector('.share-button__copy')
            ?.addEventListener('click', this.copyToClipboard.bind(this));
          this.mainDetailsToggle
            .querySelector('.share-button__close')
            ?.addEventListener('click', this.close.bind(this));
        }
      }

      toggleDetails() {
        if (!this.mainDetailsToggle?.open) {
          this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.textContent = '';
          this.elements.closeButton.classList.add('hidden');
          this.elements.shareSummary.focus();
        }
      }

      copyToClipboard() {
        navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        });
      }

      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
      }
    }
  );
}
